<template>
  <v-row>
    <v-col
      cols="12"
      md="6"
    >
      <h2 class="title pb-4">
        <v-chip
          class="ma-2"
          label
          color="warning"
        >
          Neu
        </v-chip>
        Intelligente E-Mail-Funnels
      </h2>
      <p>
        Ab jetzt können Sie unseren neuen intelligenten E-Mail-Funnel nutzen. Dieser erkennt, welche Interessen Ihre Kontakte haben und passt die Funnel-E-Mails entsprechend an.
        Auf diese Weise erhält jeder Kontakt nur relevante Inhalte.
      </p>
      <h3>Wie aktiviere ich den neuen Funnel?</h3>
      <template v-if="isDomainVerified">
        <p>Sie haben Ihre Domain bereits mittels DKIM & Return-Path verifiziert. Aktivieren Sie nun den neuen intelligenten Funnel mit nur einem Klick:</p>
        <v-btn
          class="my-2"
          color="primary"
          :loading="loading"
          :disabled="loading"
          @click="startActivation"
        >
          Funnel jetzt Aktivieren
        </v-btn>
      </template>
      <template v-else-if="isSenderVerified">
        <p>Sie haben Ihre Absender-Adresse bereits verifiziert. Aktivieren Sie nun den neuen intelligenten Funnel mit nur einem Klick:</p>
        <v-btn
          class="my-2"
          color="primary"
          :loading="loading"
          :disabled="loading"
          @click="startActivation"
        >
          Funnel jetzt Aktivieren
        </v-btn>
      </template>
      <template v-else>
        <p>Aktivieren Sie den neuen intelligenten Funnel mit nur zwei Klicks:</p>
        <ol>
          <li>Versand der Bestätigungs-E-Mail auslösen:</li>
          <v-btn
            class="my-2"
            color="primary"
            :loading="loading"
            :disabled="loading"
            small
            @click="startActivation"
          >
            Bestätigungsmail anfordern
          </v-btn>
          <p>Die E-Mail wird an <strong>{{ company?.ambassador?.email }}</strong> gesendet.</p>
          <li>Öffnen Sie die E-Mail von "Postmark-Support" und klicken Sie darin auf den Button "Confirm Sender Signature", um die Aktivierung abzuschließen.</li>
        </ol>
      </template>
    </v-col>
    <v-col
      v-if="$vuetify.breakpoint.mdAndUp"
      :md="isDomainVerified || isSenderVerified ? 5 : 6"
    >
      <div class="design-wrapper">
        <Leaf
          class="design-elements"
          width="1000"
          style="top:-300px; right: -750px; opacity: 0.2"
          fill
        />
      </div>

      <v-img
        :src="require('@/../public/img/email-computer.svg')"
        height="450px"
        style="z-index:10"
        contain
      />
    </v-col>
  </v-row>
</template>

<script>
import START_HOPPERMATION_ACTIVATION from './queries/StartHoppermationActivation.gql'
import HOPPERMATION_ORGANIZATION from '@/modules/emailVerification/queries/HoppermationOrganization.gql'
import AMBASSADOR from './queries/Ambassador.gql'
import HOPPERMATION_DEFAULT_SENDER from '@/modules/emailVerification/queries/HoppermationDefaultSender.gql'
import GET_DOMAIN from '@/queries/GetDomain.gql'
import bus, { eventNames } from '@/lib/eventBus'
import Leaf from '@/components/design-elements/leaf.vue'

export default {
  components: { Leaf },
  props: {
    organization: { type: Object, default: () => {} },
    defaultSender: { type: Object, default: () => undefined },
    onDefaultSenderCreated: { type: Function, default: () => ({}) }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    isDomainVerified () {
      return this.domain?.isDKIMVerified && this.domain?.isReturnPathDomainVerified
    },
    isSenderVerified () {
      return this.defaultSender?.isVerified
    }
  },
  apollo: {
    domain: {
      query: GET_DOMAIN,
      variables () {
        return { companyId: this.$auth.user.companyId }
      }
    },
    company: {
      query: AMBASSADOR,
      variables () {
        return { id: this.$auth.user.companyId }
      }
    }
  },
  methods: {
    updateQuery (store, { data: { organization } }) {
      const data = store.readQuery({ query: HOPPERMATION_ORGANIZATION, variables: { companyId: this.$auth.user.companyId } })
      data.organization = organization
      store.writeQuery({ query: HOPPERMATION_ORGANIZATION, data, variables: { companyId: this.$auth.user.companyId } })
    },
    async startActivation () {
      this.loading = true
      try {
        await this.$apollo.mutate({
          mutation: START_HOPPERMATION_ACTIVATION,
          variables: { companyId: this.$auth.user.companyId },
          update: this.updateQuery,
          refetchQueries: [{
            query: HOPPERMATION_DEFAULT_SENDER,
            variables: { companyId: this.$auth.user.companyId }
          }]
        })
        if (this.isDomainVerified || this.isSenderVerified) {
          bus.$emit(eventNames.SHOW_SNACKBAR, {
            color: 'success',
            text: 'Intelligente E-Mail-Funnels werden jetzt aktiviert.'
          })
        } else {
          this.onDefaultSenderCreated()
          bus.$emit(eventNames.SHOW_SNACKBAR, {
            color: 'success',
            text: 'Bestätigungs-E-Mail erfolgreich versendet. Schauen Sie jetzt in Ihr E-Mail Postfach und ggfs. in den Spam-Ordner!'
          })
        }
      } catch (err) {
        bus.$emit(eventNames.SHOW_SNACKBAR, { color: 'error', text: 'Fehler beim Senden der Verifizierungsemail.' })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.design-wrapper {
  position: relative;
  width:300px;
  height: 1px;
}

.design-elements{
  position: absolute;
  z-index: 1;
  pointer-events: none;
}

.flip-horizontal, .x-grid-cell-inner, .x-column-header-text, .x-panel-header-text {
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    transform: scaleX(-1);
    -ms-filter: fliph; /*IE*/
    filter: fliph; /*IE*/
}
</style>
